import React, { useEffect, useState } from "react";
import { Modal, Button, Icon } from "antd";
import { useWatchState, usePage } from "@/store";
import { BaseService } from "@/service";
import { FileList } from "@/components";
import { checkResult, createFilePath } from "@/common";
import "./style.less";

const NAME = "pushResult";

const View = () => {

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[props]] = useWatchState(["modal." + NAME])
    const { title = "推送配置", show, hide, pushWechatId, itemId, orgAdmin = false } = props;

    const [onItem, setOnItem] = useState("");
    const [wid, setWId] = useState("");
    const [orgGroup, setOrgGroup] = useState([]);

    useEffect(() => {
        if (itemId) setOnItem(itemId);
        if (pushWechatId) setWId(pushWechatId);
    }, [itemId, pushWechatId])

    useEffect(() => {
        if (onItem) {
            orgsControl.clear();
            orgsControl.go(1);
        }
    }, [onItem])

    useEffect(() => {
        if (wid) {
            console.log("clear")
            itemsControl.clear();
            orgsControl.clear();

            itemsControl.go(1);
            orgsControl.go(1);
        }
    }, [wid])

    const [items = [], itemsControl] = usePage({
        atonce: false,
        cache: true,
        service: BaseService.list,
        size: 20,
        params: {
            table: "thtt_push_group_items",
            where: {
                push_wechat_ids: pushWechatId
            },
            leftJoin: {
                table: "thtt_xuqiu",
                on: "thtt_push_group_items.item_id = thtt_xuqiu.xuqiu_id",
                columns: JSON.stringify(["name AS itemName"])
            }
        },
        format: res => res.data.result.records,
        after: (data) => {
            if (!itemId) setOnItem(data[0].item_id)
        }
    })
    const [orgs = [], orgsControl] = usePage({
        atonce: false,
        cache: true,
        service: BaseService.list,
        size: 20,
        params: {
            table: "thtt_push_wechat_orgs",
            columns: "id,org_id",
            where: orgAdmin
                ? {
                    push_id: pushWechatId,
                    org_id: orgAdmin
                }
                : {
                    push_id: pushWechatId,
                },
            leftJoin: {
                table: "thtt_organization",
                on: "thtt_push_wechat_orgs.org_id = thtt_organization.organization_id",
                columns: JSON.stringify(["name AS orgName"])
            },
            process: {
                name: "feedbacks",
                key: "org_id",
                targetKey: "org_id",
                params: {
                    table: "thtt_feedback",
                    where: {
                        item_id: onItem,
                        push_wechat_id: pushWechatId
                    }
                }
            }
        },
        format: res => res.data.result.records,
    })

    return (
        <Modal
            title={title}
            visible={show}
            width="80vw"
            maskClosable={false}
            onCancel={hide}
            footer={(
                <div className="flex row-end child-left-sm">
                    <Button onClick={hide}>取消</Button>
                </div>
            )}
        >
            <div className="flex child-full">
                {Boolean(items.length) && <div>
                    {items.map(({ item_id, itemName }) => (
                        <p onClick={setOnItem.later(item_id)} className={`modal-pushResult__push-item ${item_id === onItem && "modal-pushResult__push-item--active"}`}>{itemName}</p>
                    ))}
                </div>}
                <div className="child-top-sm">
                    {orgs.map(({ orgName, feedbacks = [] }) => (
                        <div>
                            <p className="bold">{orgName}（共{feedbacks.length}条反馈信息）</p>
                            {feedbacks.map(({ wechat_name, phone, name, add_time, remark, files }) => (
                                <div className="p-sm border-left">
                                    <div className="child-top-xs">
                                        <p className="dark-disable font-size-14">{new Date(add_time).format("yyyy-MM-dd hh:mm:ss")}</p>
                                        <p className="child-left-sm">
                                            <span><Icon type="wechat" style={{ color: "#65b257" }} /> {wechat_name}</span>
                                            <span>{phone}</span>
                                            <span>{name}</span>
                                        </p>
                                    </div>
                                    <div className="p-sm child-top-sm">
                                        <p className="dark-second font-size-14">{remark}</p>
                                        <FileList data={JSON.parse(files).map(o => ({ ...o, url: createFilePath(o.url, UPLOAD_SERVER_HOST) }))} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
}

export default View;